import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVault: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVault"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V19H6V21H7.5V19H16.5V21H18V19H21V3H3ZM16.5 11C16.5 13.4853 14.4853 15.5 12 15.5C9.77025 15.5 7.91928 13.8783 7.56222 11.75H12V10.25H7.56222C7.91928 8.12172 9.77025 6.5 12 6.5C14.4853 6.5 16.5 8.51472 16.5 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVault;
